import { ImpactStyle, Haptics } from '@capacitor/haptics';
import { isInMobilePlatform } from '@fabric-app/compat/capabilities/platform';

const FabricHaptics = {
  setHapticsEnabled: (enabled) => {
    document.body.setAttribute("data-fabric-haptics", enabled);
  },
  impact: (options) => {
    if (document.body.getAttribute("data-fabric-haptics") === "none") {
      return;
    }
    if (isInMobilePlatform()) {
      Haptics.impact(options);
    } else if (typeof navigator !== "undefined" && "vibrate" in navigator) {
      navigator.vibrate(50);
    }
  },
  ImpactStyle
};

export { FabricHaptics };
//# sourceMappingURL=FabricHaptics.js.map
